import React, { MutableRefObject } from 'react';
import { useTranslation } from 'react-i18next';
import { Alert, Box, FormField } from '@chargify/custom-ui-components';
import { renderField, CustomField } from '@chargify/custom-fields';

type CustomFieldsFormProps = {
  customFields: CustomField[];
  onChange: (id: number, value: string | number) => void;
  isError: boolean;
  portalContainer: MutableRefObject<HTMLDivElement>;
};

const CustomFieldsForm = ({
  customFields,
  onChange,
  isError,
  portalContainer,
}: CustomFieldsFormProps) => {
  const { t } = useTranslation(['customer-details']);

  return (
    <>
      {isError && (
        <Box marginBottom={5}>
          <Alert color="danger">
            <Alert.TextMessage>
              {t('error.we_were_unable_to_save_your_custom_fields')}
            </Alert.TextMessage>
          </Alert>
        </Box>
      )}
      <Box width={200}>
        {customFields.map(({ name, id, fieldType, value, enum: options }) => (
          <FormField label={name} name={name} key={id} fullWidth>
            {renderField({
              portalContainer,
              id,
              name,
              fieldType,
              value: value || '',
              options,
              onChange,
              maxLength: 2048,
            })}
          </FormField>
        ))}
      </Box>
    </>
  );
};

export default CustomFieldsForm;
